export enum SizerType {
  Default = 'default',
  Commercial = 'commercial',
}
